import { __rest } from "tslib";
import React from 'react';
import Map from '../../components/Map/Map';
import MediaBase from '../../components/MediaBase/MediaBase';
export const MapBlock = (_a) => {
    var { map } = _a, props = __rest(_a, ["map"]);
    return (React.createElement(MediaBase, Object.assign({}, props),
        React.createElement(MediaBase.Card, null,
            React.createElement(Map, Object.assign({}, map)))));
};
export default MapBlock;
